// Note: Types exported from `index.d.ts`.
export {mathFromMarkdown, mathToMarkdown} from './lib/index.js'
